// Embed Block - Generic iframe embed
class EmbedBlock {
  static get toolbox() {
    return {
      title: 'Embed',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>'
    };
  }

  static get isReadOnlySupported() {
    return true;
  }

  constructor({ data, config, api, readOnly }) {
    this.data = {
      url: data.url || '',
      height: data.height || 400,
      caption: data.caption || ''
    };
    this.readOnly = readOnly;
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement('div');
    this._render();
    return this.wrapper;
  }

  _render() {
    this.wrapper.innerHTML = `
      <div class="embed-block" data-testid="embed-block">
        ${!this.readOnly ? `
          <div class="flex gap-2 mb-2">
            <input type="text" class="url-input flex-1 px-3 py-2 rounded border text-sm" placeholder="Embed URL..." value="${this.data.url}" />
            <input type="number" class="height-input px-3 py-2 rounded border text-sm w-24" placeholder="Height" value="${this.data.height}" />
          </div>
        ` : ''}
        ${this.data.url ? `
          <div class="rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700">
            <iframe src="${this.data.url}" class="w-full" style="height: ${this.data.height}px" frameborder="0"></iframe>
          </div>
          ${this.data.caption || !this.readOnly ? `
            <div class="mt-2 text-center">
              ${!this.readOnly ? `
                <input type="text" class="caption-input w-full px-2 py-1 text-sm text-slate-500 bg-transparent border-0 focus:outline-none text-center" placeholder="Add caption..." value="${this.data.caption}" />
              ` : `<p class="text-sm text-slate-500">${this.data.caption}</p>`}
            </div>
          ` : ''}
        ` : `
          <div class="p-8 border-2 border-dashed border-slate-300 dark:border-slate-600 rounded-lg text-center text-slate-400">
            Enter an embed URL
          </div>
        `}
      </div>
    `;

    if (!this.readOnly) {
      this.wrapper.querySelector('.url-input')?.addEventListener('input', (e) => {
        this.data.url = e.target.value;
        this._render();
      });
      this.wrapper.querySelector('.height-input')?.addEventListener('input', (e) => {
        this.data.height = parseInt(e.target.value) || 400;
        this._render();
      });
      this.wrapper.querySelector('.caption-input')?.addEventListener('input', (e) => {
        this.data.caption = e.target.value;
      });
    }
  }

  save() {
    return this.data;
  }
}

export default EmbedBlock;
